import httpManager from "@/app/shared/utils/httpManager";
import { toFormData } from "@/app/shared/utils/helpers";
/**
 * Editar una capaña
 *
 * Los campos ausentes en `portfolio` no se envían (backend no los toca). Para limpiar
 * media, troncal o identificadores de correo se envían vacíos de forma explícita.
 *
 * @param {Object} portfolio Datos de la campaña a editar
 *
 * @return {Promise<Object>} Datos de la campaña editada
 */
export async function updatePortfolio(portfolioId, portfolio) {
  console.log(portfolio, "portfolio");
  const body = portfolio;
  if (!body.is_enable_time_acw) delete body.time_acw;
  if (!body.is_enable_call_time) delete body.call_time;
  if (!body.description) delete body.description;
  if (!body.customized_management) delete body.customized_management;
  else body.customized_management = JSON.stringify(body.customized_management);

  const hasChannelCustomer = "channel_customer" in body;
  const channelCustomer = Array.isArray(body.channel_customer) ? [...body.channel_customer] : [];
  delete body.channel_customer;

  // Archivo nuevo va en media_negotiation; si no, media_url mantiene (url) o borra ("")
  if ("media_negotiation" in body && !(body.media_negotiation instanceof File)) {
    body.media_url = body.media_negotiation || "";
    delete body.media_negotiation;
  }

  // "Sin troncal VOIP" tiene id null; backend interpreta "" como sin troncal
  if ("voip_provider" in body) body.voip_provider = body.voip_provider ?? "";

  if ("text_negotiation" in body) body.text_negotiation = body.text_negotiation || "Sin speech";
  const formData = toFormData(body, { avoidEmpty: true, avoidFalse: false });

  if (hasChannelCustomer) {
    if (channelCustomer.length === 0) formData.append("channel_customer", "");
    channelCustomer.forEach((channel) => {
      formData.append("channel_customer", channel);
    });
  }

  const url = `/portfolios/${portfolioId}/`;
  const response = await httpManager.uploadPut(url, formData);
  return response.data;
}
